module.exports = __webpack_public_path__ + "img/antes_despues_57.7e19240f.png";